import { createApi } from "@reduxjs/toolkit/query/react";

import type { IApiGeneralParams } from "@/types";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { COUNTRIES_ALL, NATIONALITY_ALL } from "@/constants/apiEndpoints";
import type { TGetCountriesDataResponse } from "@/types/(my-space)/countries.interface";

export const countriesApi = createApi({
  reducerPath: "countriesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["getCountries"],
  endpoints: (builder) => ({
    getAllCountries: builder.query<
      TGetCountriesDataResponse,
      IApiGeneralParams
    >({
      query: () => ({
        url: COUNTRIES_ALL,
        method: "GET",
      }),
    }),
    getAllNationality: builder.query<
      TGetCountriesDataResponse,
      IApiGeneralParams
    >({
      query: () => ({
        url: NATIONALITY_ALL,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllCountriesQuery, useGetAllNationalityQuery } =
  countriesApi;
